import { Component, OnInit, ViewChildren, QueryList, ElementRef, ViewChild, Input } from '@angular/core';
import { GridsterConfig, GridsterItem, GridsterItemComponentInterface, GridType } from 'angular-gridster2';
import { DashboardService } from './dashboard.service';
import { DashboardItem, DashboardModel } from '../models';
import { CoreService } from '../services';
import { DialogService } from '../dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {

  public dashboardCollection: Array<DashboardItem>;
  public dashboardItems: Array<DashboardItem>;
  public isModify: boolean;
  public options: GridsterConfig;
  public loadGridster: boolean;
  public isAdmin: boolean;
  private idRole: string;
  private idContext: string;
  public roles: Array<{ id: string, Name_ROL: string, selected: boolean }>;
  public lanceurs: Array<{ id: string, Info_LAN: string, selected: boolean }>;

  @ViewChildren('gridItemList') gridItemList: QueryList<any>;
  @ViewChild('invisibleSplash', { static: false }) invisibleSplash: ElementRef;

  @Input('Admin') Admin: boolean;
  constructor(
    private dashboardservice: DashboardService,
    private indParam: CoreService,
    private dialogservice: DialogService,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((routeParams: any) => {
    });
    this.isAdmin = this.indParam.getAutorisation('AdminDashBoard');
    this.isModify = false;
    this.dashboardItems = [];
    if (this.isAdmin && this.Admin) {
      this.options = {
        gridType: GridType.ScrollVertical,
        itemResizeCallback: this.itemResize.bind(this),
        itemChangeCallback: this.itemChange.bind(this),
        enableEmptyCellDrop: true,
        emptyCellDropCallback: this.emptyCellClick.bind(this),
        mobileBreakpoint: 768,
        minCols: 12,
        maxCols: 12,
        minRows: 20,
        maxRows: 20,
        maxItemArea: 40,
        resizable: {
          enabled: true,
        },
        draggable: {
          enabled: true,
          dragHandleClass: 'draggable',
        }
      };
    } else {
      this.options = {
        gridType: GridType.ScrollVertical,
        itemResizeCallback: this.itemResize.bind(this),
        itemChangeCallback: this.itemChange.bind(this),
        enableEmptyCellDrop: true,
        emptyCellDropCallback: this.emptyCellClick.bind(this),
        mobileBreakpoint: 768,
        minCols: 12,
        maxCols: 12,
        minRows: 20,
        maxRows: 20,
        maxItemArea: 40,
        resizable: {
          enabled: false,
        },
        draggable: {
          enabled: false,
          dragHandleClass: 'draggable',
        }
      };
    }

    this.loadGridster = false;
    this.dialogservice.showSplash(true);
    this.dashboardservice.getRolesAndContext().subscribe(
      (res: { roles: Array<{ id: string, Name_ROL: string, selected: boolean }>, lanceurs: Array<{ id: string, Info_LAN: string, selected: boolean }> }) => {
        this.roles = res.roles;
        this.lanceurs = res.lanceurs;
        if (this.isAdmin) {
          this.idRole = res.roles[0].id;
        } else {
          this.idRole = this.indParam.AppParams.Role.Id;
        }
        this.idContext = res.lanceurs[0].id;
        this.roles.forEach((role: { id: string, Name_ROL: string, selected: boolean }) => {
          if (this.idRole === role.id) {
            role.selected = true;
          } else {
            role.selected = false;
          }
        });
        this.lanceurs.forEach((lanceur: { id: string, Info_LAN: string, selected: boolean }) => {
          if (this.idContext === lanceur.id) {
            lanceur.selected = true;
          } else {
            lanceur.selected = false;
          }
        });
        this.getColletionDashboard();
      });
  }

  public selectRole(idRole: string): void {
    this.idRole = idRole;
    this.getColletionDashboard();
  }

  public selectLanceur(idLanceur: string): void {
    this.idContext = idLanceur;
    this.getColletionDashboard();
  }


  // Envoi les informations de l'item à la grid et cache le slider pendant le dragover
  public drag(item: DashboardItem): void {
    this.dashboardservice.sendItem(item);
  }

  // #region FONCTIONS PRIVEES
  // parametres optionels lié à la librairie gridster2
  private itemChange(item: GridsterItem, itemComponent: GridsterItemComponentInterface): void {
    this.saveDashboard();
  }

  // Récupere et envoi au composant la taille et l'id du composant modifié ou droppé dans la grid
  private itemResize(item: DashboardItem, itemComponent: GridsterItemComponentInterface): void {
    this.sendSizeItems(item);
  }

  // Récupere la taille et l'id de chaque item affiché dans le gridster
  private sendSizeItems(item: DashboardItem): void {
    this.loadGridster = false;
    let _id: string = '';
    let _height: number = 0;
    let _width: number = 0;
    this.gridItemList.forEach((e: any) => {
      if (e.item.id === item.id) {
        _id = e.item.id;
        _height = e.el.clientHeight;
        _width = e.el.clientWidth;
      }
    });
    for (let i: number = 0; i < this.dashboardItems.length; i++) {
      if (this.dashboardItems[i].id === _id) {
        this.dashboardItems[i].inputs.size = {
          height: _height,
          width: _width
        };
        this.dashboardservice.sendSize(this.dashboardItems);
        break;
      }
    }
    this.loadGridster = true;
    this.dialogservice.showSplashInvisible(false);
  }

  // Suppression d'un élement de la grid
  public removeItem(e: any, item: DashboardItem): void {
    this.dashboardItems.splice(this.dashboardItems.indexOf(item), 1);
    for (let i: number = 0; i < this.dashboardCollection.length; i++) {
      if (item.id === this.dashboardCollection[i].id) {
        this.dashboardCollection[i].isVisible = false;
        break;
      }
    }
    // if (!this.dashboard.length) {
    //   this.OpenModal.nativeElement.click();
    // }
    this.saveDashboard();
  }

  // evenement d'enregistrement du nouveau dashboard
  private saveDashboard(): void {
    if (this.isAdmin) {
      this.dialogservice.showSplash(true);
      this.dashboardservice.saveDashboard(this.idRole, this.idContext, this.dashboardCollection).subscribe((result: DashboardModel) => {
        this.dialogservice.showSplash(false);
      });
    }
  }

  private getColletionDashboard(): void {
    this.dashboardservice.getCollection(this.idContext, this.idRole).subscribe((dash: DashboardModel) => {
      this.dashboardCollection = dash.DashboardItemList;
      if (this.dashboardCollection) {
        this.dashboardItems = this.dashboardCollection.filter((item: DashboardItem) => item.isVisible);
      }
      this.loadGridster = true;
      this.dialogservice.showSplash(false);
    });
  }

  // Evenement au drop d'un nouveau composant dans la grid
  private emptyCellClick(event: MouseEvent, item: GridsterItem): void {
    const obj: DashboardItem = this.dashboardservice.getItem();
    if (obj !== null) {
      let newItem: DashboardItem = new DashboardItem();
      newItem = obj;
      newItem.x = item.x;
      newItem.y = item.y;
      this.dashboardItems.push(newItem);
      for (let i: number = 0; i < this.dashboardCollection.length; i++) {
        if (newItem.id === this.dashboardCollection[i].id) {
          this.dashboardCollection[i].isVisible = true;
          break;
        }
      }
    }
    this.saveDashboard();
  }
}
